import React, {Component} from "react";
import "./history.css";
import HistoryEntry, {HistoryEntryProps} from "./historyEntry";
import LanguageDetails , {LanguageDetailsProps} from "./languageDetails";
import {faCertificate, faLocationArrow, faScroll} from "@fortawesome/free-solid-svg-icons";


export default class History extends Component {

    static workExperience : HistoryEntryProps[] = [
        {
            image: "betssonlogo.png",
            title: "Betsson Group",
            link: "https://www.betssongroup.com/",
            description: [
                <p key={"betsson-0"}>Building and leading high-performing engineering teams, working closely with product and design counterparts on the planning and scoping of the product development roadmap. Ensuring technical stability and performance of the applications under the tutelage of my teams.</p>,
                <p key={"betsson-1"}>Ensuring the engineering teams are properly structured, staffed and posses the right roles and skills. Driving excellence in engineering recruitment, onboarding and career development. Fostering a culture of ownership, collaboration and passion for delivering quality products</p>,
                <p key={"betsson-2"}>Collaborating with other engineering leaders across the organisation to share best practices.</p>,
                <p key={"betsson-3"}>Defining, monitoring and reporting team performance metrics to measure productivity. Driving continuous optimisation and improvement of the team and development processes. Advocating and advancing modern agile software development practices.</p>,
                <p key={"betsson-4"}>Construction of infrastructure to collect and represent team metrics using GCP Cloud functions, Big Query and Looker Studio</p>,
                <p key={"betsson-5"}>Driving adoption of AI-assisted development across the engineering organisation: using Cursor and GitHub Copilot for coding, agentic AI and agentic mode for planning and building workflows that support the software lifecycle across multiple agents and stages (design, development, testing, release).</p>,
            ],
            subEntries: [
                {
                    subtitle: "Engineering Manager",
                    dateRange: "December 2024 onwards",
                    sterileDateRange: "December 2024 onwards",
                    fontawesome: faScroll
                }
            ]
        },
        {
          image: "ecabslogo.svg",
          title: "eCabs Technologies Limited (prev. Cuorium)",
          link: "https://www.ecabs.com.mt/",
          description: [
              <p key={"ecabs-0"}>Managed a multi-country, multi-discipline technology department to facilitate the implementation and upkeep of a taxi management system.</p>,
              <p key={"ecabs-1"}>Involved in and overseeing the transformation of the local self-hosted system into a Google Cloud-based multi-project, multi-tenant, microservice platform. Integration included technologies such as Java, GoLang, Angular, Kubernetes (GKE, Helm), Terraform, together with several cloud-based solutions such as Pub/Sub, CloudArmor, Cloud Storage, Big Query, Cloud SQL, Memorystore (Redis), Firebase, and CI/CD tools such as Jenkins and Artifact Registry.</p>,
              <p key={"ecabs-2"}>Managed the entire technology team, including Backend Teams (primarily Java), Mobile Team (Android and iOS native), Frontend (Angular), QA (Manual & Automation), NOC (Cloud-based System Monitoring), Data (PowerBI).</p>,
              <p key={"ecabs-3"}>Scaled up the team from ~10 to ~70 members over 3 years, introducing a NOC team for live process monitoring. Achieved through in-house specialization and contractor hiring, fostering a remote-first culture due to the multi-country nature of the team.</p>,
              <p key={"ecabs-4"}>Introduced processes to organize workflows across all levels for better management and planning of roadmap work, enabling clearer goal focus. Streamlined all stages from solution conception/design through development, release, and monitoring. Main goals were to improve team cohesiveness in an automated fashion, ensuring independence and voice for all teams.</p>,
              <p key={"ecabs-5"}>Developed team members' interpersonal and academic growth through individual career path attention and facilitating necessary training.</p>,
              <p key={"ecabs-6"}>Managed the ISO 27001 certification process.</p>,
              <p key={"ecabs-7"}>Managed initial interaction with 3rd party vendors/suppliers to streamline communication, reduce bottlenecks, and ensure observable work allocation.</p>,
              <p key={"ecabs-8"}>Acted as a bridge between the Executive Committee and the tech team to provide insight into the current and forecasted workload. Consolidated the Technology Vision based on investor requirements, encouraging innovation and tech stack enhancement for optimal results.</p>,
              <p key={"ecabs-9"}>Other technologies used include the Atlassian Stack (JIRA, Confluence, Bitbucket, OpsGenie) and monday.com.</p>
          ],
          subEntries: [
              {
                  subtitle: "acting CTO",
                  dateRange: "April 2024 - November 2024",
                  sterileDateRange: "8 months",
                  fontawesome: faScroll
              },
              {
                  subtitle: "Head of Development",
                  dateRange: "Oct 2021 - November 2024",
                  sterileDateRange: "3 years 1 month",
                  fontawesome: faScroll
              },
              {
                  subtitle: "Full Stack Developer",
                  dateRange: "Aug 2021 - Oct 2022",
                  sterileDateRange: "1 year 2 months",
                  fontawesome: faScroll
              }
          ]
        },
        {
            image : "relax.png",
            title: "Relax Gaming",
            link : "https://relax-gaming.com/",
            description: [
                <p key={"relax-0"}>Led the implementation of game engine backend APIs by converting Mathematical Spec Documents into Java APIs, including RTP matching and construction of Round History images.</p>,
                <p key={"relax-1"}>Organized and structured internal team workflows on JIRA and core coding practices and infrastructure such as Gitflow, Maven, and Sonatype Nexus.</p>,
                <p key={"relax-2"}>Managed release management in a semi-automated process and coordinated development issues across multiple business teams.</p>,
                <p key={"relax-3"}>Handled internal administration of developer environment VMs to deploy development tools such as Jenkins and SonarQube through Docker.</p>,
                <p key={"relax-4"}>Managed a team of 2 developers, which scaled up to 8 over time, while closely collaborating with the QA team.</p>
            ],
            subEntries: [
                {
                    subtitle: "Lead Game Engine Developer",
                    dateRange: "Feb 2020 - 4 Aug 2021",
                    sterileDateRange: "1 year 6 months",
                    fontawesome: faScroll
                },
                {
                    subtitle: "Game Engine Developer",
                    dateRange: "Mar 2018 - Feb 2020",
                    sterileDateRange: "2 years",
                    fontawesome: faScroll
                }
            ]
        },
        {
          image: "tctc.png",
          title: "TCTC",
          link: "https://www.tctcmalta.com/en/home.htm",
          description: [
              <p key={"tctc-0"}>Taught robotics and programming concepts to children aged 7 to 14 during summer sessions.</p>
          ],
          subEntries: [
              {
                  subtitle: "Robotica Instructor",
                  dateRange: "July - September 2021",
                  sterileDateRange: "3 Months (Summer course)",
                  fontawesome: faScroll
              },
              {
                  subtitle: "Programming Instructor",
                  dateRange: "July - September 2021",
                  sterileDateRange: "3 Months (Summer course)",
                  fontawesome: faScroll
              }
          ]
        },
        {
            image : "lottostarlet.png",
            contrastImageBackground : true,
            title: "LottoStarlet",
            description: [
                <p key={"lotto-0"}>Joined the startup as a developer and progressed to become the manager of the tech team. Led backend implementation for a secondary lottery website using Java and Spring, from initial development through post-live maintenance.</p>,
                <p key={"lotto-1"}>Designed the architecture spanning both Java backend and Angular 2 frontend, and oversaw server infrastructure administration for both live and development environments, utilizing a combination of Docker-based and raw-OS installations.</p>,
                <p key={"lotto-2"}>Managed the certification process through MGA (Malta Gaming Authority).</p>,
                <p key={"lotto-3"}>Led the team's growth from 2 developers to 7 developers, along with additional roles such as QA and Design, while collaborating closely with Marketing to deliver comprehensive solutions.</p>
            ],subEntries: [
                {
                    subtitle: "Software Architect",
                    dateRange: "30 Jun 2017 - 30 Jan 2018",
                    sterileDateRange: "1 year",
                    fontawesome: faScroll
                },
                {
                    subtitle: "Senior Backend Developer",
                    dateRange: "24 Apr 2017 - 20 Jun 2017",
                    sterileDateRange: "2 months",
                    fontawesome: faScroll
                }
            ]
        },
        {
            image : "imagina.png",
            contrastImageBackground : true,
            title: "Imagina Gaming (prev. Casinova)",
            description: [
                <p key={"imagina-0"}>Led the ground-up implementation of a Microservice-based Slot Gaming Platform using Java, Akka, and actors for the backend, with ReactJS for the frontend.</p>,
                <p key={"imagina-1"}>Constructed an internal real-time Data-Warehousing and Reporting infrastructure.</p>,
                <p key={"imagina-2"}>Set up the internal development environment on servers, including tools like Jenkins, JIRA, and Jetbrains Upsource.</p>,
                <p key={"imagina-3"}>Joined as one of the initial three members of the startup development team, which later scaled up to six members.</p>
            ],
            subEntries: [
                {
                    subtitle: "Software Engineer",
                    dateRange: "Jun 2016 - Apr 2017",
                    sterileDateRange: "1 year",
                    fontawesome: faScroll
                }
            ]
        },
        {
            image : "ixaris.svg",
            title: "Ixaris Systems",
            link : "https://www.nium.com/",
            description:[
                <p key={"ixaris-0"}>Contributed to the implementation of the Core layer of a Virtual Credit Card Financial Platform using Java and AngularJS.</p>,
                <p key={"ixaris-1"}>Assisted in setting up tools such as GitLab and participated in the automation of the release process using Puppet and Ansible.</p>,
                <p key={"ixaris-2"}>Participated in Proof of Concept testing of technologies for a microservice-based architecture migration, including Kubernetes, Message Queues, asynchronous APIs, and Future-based implementations.</p>,
                <p key={"ixaris-4"}>Worked as part of a core team of 8 developers, within a larger group of 30+ developers and QA.</p>
            ],
            subEntries: [
                {
                    subtitle: "Junior Software Engineer",
                    dateRange: "Jun 2014 - Jun 2016",
                    sterileDateRange: "2 years",
                    fontawesome: faScroll
                }
            ]
        },
        {
            image : "hob.png",
            contrastImageBackground : true,
            title: "HOB Software",
            link: "https://en.wikipedia.org/wiki/HOB_GmbH_%26_Co_KG",
            description: [
                <p key={"hob-0"}>Contributed to the implementation of a Java-based VPN testing tool for an internal L2TP/IPSec VPN running on Ubuntu.</p>,
                <p key={"hob-1"}>Contributed to the implementation of a JSF-based internal HR and payroll management tool.</p>,
                <p key={"hob-2"}>Assisted in the management of servers and automation of processes using Python.</p>,
                <p key={"hob-3"}>Worked as part of a team of 2 developers, within a larger group of 15+ developers.</p>
            ],
            subEntries: [
                {
                    subtitle: "Junior System Administrator",
                    dateRange: "Feb 2014 - Jun 2014",
                    sterileDateRange: "4 months",
                    fontawesome: faScroll
                },
                {
                    subtitle: "Software Developer",
                    dateRange: "Jun 2011 - Sep 2013",
                    sterileDateRange: "2 years 4 months",
                    fontawesome: faScroll
                }
            ]
        }
    ];

    static personalProjects : HistoryEntryProps[] = [
        {
            title: "AI-Quickstart",
            link: "https://github.com/aaron-axisa/AI-Quickstart",
            description: [
                <p key={"ai-quickstart-0"}>A one-line installer that sets up AI coding tools on a repository. It supports Caveman, Graphify, Karpathy guidelines, Spec Kit, and related skills. You point it at a repo, pick tools and platforms (Cursor, Claude, Codex, and others), and it installs the matching rules, skills, and hooks.</p>,
                <p key={"ai-quickstart-1"}>Built so AI setup is consistent across repos instead of being done by hand each time.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2026",
                    sterileDateRange: "2026",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "Kingdom Hearts Personality Quiz",
            link: "https://kh-who-are-you.vercel.app/",
            description: [
                <p key={"kh-quiz-0"}>An unofficial fan personality quiz (~20 questions, about 5 minutes). Built with AI assistance, and used as a way to learn Vercel hosting including deploy, preview, and production.</p>,
                <p key={"kh-quiz-1"}>The site also uses the Amazon Associates affiliate program.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2026",
                    sterileDateRange: "2026",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "Time Weave",
            link: "https://timeweave.online",
            description: [
                <p key={"timeweave-0"}>A Next.js and React timeline tool with a custom YAML-based DSL for building interactive timelines. This was an experiment in a fully frontend project: there is no backend, so data and rendering stay in the browser.</p>,
                <p key={"timeweave-1"}>Built with Cursor. The live site also uses Google AdSense.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2025",
                    sterileDateRange: "2025",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "T-shirt Sewing Pattern Generator (WIP)",
            link: "https://impawtant.business/sewing/tshirt",
            description: [
                <p key={"tshirt-0"}>A comprehensive ReactJS-based application for generating custom sewing patterns as printable SVG files. This project demonstrates advanced mathematical modeling capabilities, particularly in curve calculations and geometric transformations essential for accurate pattern generation.</p>,
                <p key={"tshirt-1"}>The application incorporates complex algorithms for curve interpolation, pattern scaling, and seam allowance calculations. Built with modern React patterns and SVG manipulation libraries, it provides a professional-grade tool for fashion designers and sewing enthusiasts, showcasing expertise in both frontend development and mathematical computation.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2023",
                    sterileDateRange: "2023",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "Expenses App",
            description: [
                <p key={"expenses-0"}>A sophisticated expense management solution built with ReactJS, Google Cloud Platform cloud functions, and MongoDB Atlas. The application implements an intelligent algorithm that minimizes the number of fund transfers required between group members while maintaining accurate balance tracking.</p>,
                <p key={"expenses-1"}>The system architecture demonstrates expertise in cloud-native development, serverless computing, and database design. The optimization algorithm for fund distribution showcases advanced problem-solving skills and understanding of financial mathematics, making it an efficient solution for group expense management scenarios.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2022",
                    sterileDateRange: "2022",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "Charades",
            link: "https://play.google.com/store/apps/details?id=com.aaronaxisa.charades_app",
            description: [
                <p key={"charades-0"}>A Flutter-based Android application that reimagines the classic charades game through innovative use of device sensors. The app leverages gyroscope detection to create an intuitive and engaging user experience, allowing players to control game flow through natural device movements.</p>,
                <p key={"charades-1"}>The application demonstrates proficiency in cross-platform mobile development, sensor integration, and game mechanics design. The gyroscope implementation showcases expertise in hardware abstraction layers and real-time sensor data processing, creating a unique and entertaining social gaming experience.</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2023",
                    sterileDateRange: "2023",
                    fontawesome: faScroll
                }
            ]
        },
        {
            title: "AI-Generated Music",
            description: [
                <p key={"music-0"}>Experimentally AI-generated music to explore the world of music publishing.</p>,
                <div key={"music-1"} className="HistoryEntry-ScreenOnly" style={{marginTop: "20px"}}>
                    <iframe 
                        data-testid="embed-iframe" 
                        style={{borderRadius: "12px"}}
                        src="https://open.spotify.com/embed/artist/4vn9PtR0wmIqshiLZULPQw?utm_source=generator"
                        width="100%" 
                        height="352" 
                        frameBorder="0" 
                        allowFullScreen
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share"
                        loading="lazy"
                        title="Spotify Artist Embed"
                        sandbox="allow-scripts allow-same-origin allow-presentation allow-forms allow-popups allow-popups-to-escape-sandbox">
                    </iframe>
                </div>,
                <p key={"music-2"} className="HistoryEntry-PrintOnly">Spotify: https://open.spotify.com/artist/4vn9PtR0wmIqshiLZULPQw</p>
            ],
            subEntries: [
                {
                    subtitle: "",
                    dateRange: "2025",
                    sterileDateRange: "2025",
                    fontawesome: faScroll
                }
            ]
        }
    ];

    static education : HistoryEntryProps[] = [
        {
            title: "Bsc. ICT Software Development",
            description: "Bachelors degree in Software Development which covers core concepts of software development varying from more theoretical subjects such as Logic, Formal languages and Automata; as well as other more practical subjects such as Web and Java Development",
            subEntries: [
                {
                    subtitle: "University of Malta",
                    dateRange: "Oct 2012 - Jun 2015",
                    sterileDateRange: "2015",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "Game Programming 1",
            description: "Game Programming course introducing generic video game development concepts. Language used was Adobe Flash.",
            subEntries: [
                {
                    subtitle: "Holistic IT Group",
                    dateRange: "Jul - Sep 2010",
                    sterileDateRange: "2010",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "ECDL",
            description: "The European Computer Driving License with advanced coverage Microsoft Office held at Savio College",
            subEntries: [
                {
                    subtitle: "ECDL Advanced - Word, Presentation",
                    dateRange: "2008 - 2009",
                    sterileDateRange: "2009",
                    fontawesome: faLocationArrow
                },
                {
                    subtitle: "ECDL",
                    dateRange: "2005 - 2007",
                    sterileDateRange: "2007",
                    fontawesome: faLocationArrow
                }

            ]
        },
        {
            title: "Square Enix Seminars",
            description: "Seminars on the visual of Final Fantasy by the art director of Final Fantasy Type-0 HD, and on the creative process behind the CG movies of Square Enix by the general manager of Visual Works (Square Enix's own CG movie production studio)",
            subEntries: [
                {
                    subtitle: "Visuals of Final Fantasy by Yusuke Naora at the SMU Guildhall",
                    dateRange: "27 Mar 2015",
                    fontawesome: faLocationArrow
                },
                {
                    subtitle: "Creaive Process behind CG movies of Square Enix by Kazuyuki Ikumori at the University of Southern California",
                    dateRange: "12 Mar 2015",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "Japanese Module I",
            description: "",
            subEntries: [
                {
                    subtitle: "Malta University Language School",
                    dateRange: "Apr 2017 - Jun 2017",
                    sterileDateRange: "2017",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "iGaming NEXT Malta Conference",
            description: "Presentations regarding new Gaming trends and available Technologies by Betconstruct, Quickspin, Shazam, NetEnt,  Microsoft, Amazon game tech.",
            subEntries: [
                {
                    subtitle: "Eden Place, St Julians, Malta",
                    dateRange: "10 Sep 2019",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "Delta Summit",
            description: "Presentations regarding the development of Artificial Intelligence, Blockchain and Gaming",
            subEntries: [
                {
                    subtitle: "MFCC, Malta",
                    dateRange: "2 - 4 Oct 2019",
                    fontawesome: faLocationArrow
                }
            ]
        },
        {
            title: "ICE Totally Gaming Conference",
            description: "Stands and seminars relating to current trends in gaming",
            subEntries: [
                {
                    subtitle: "ICE, London",
                    dateRange: "Feb 2017",
                    fontawesome: faLocationArrow
                }
            ]
        }
    ];

    static awardsAndCertifications : HistoryEntryProps[] = [
        {
            title: "Condominium Administration",
            description: "How to become a better condominium administrator. Course required for condominium administration.",
            link: "https://maltaconsulting.mt/public-courses/become-a-better-condominium-administrator/",
            subEntries: [
                {
                    subtitle: "Malta University Consulting",
                    dateRange: "6 - 10 Oct 2025",
                    fontawesome: faCertificate
                }
            ]
        },
        {
            title: "Fire safety certification",
            description: "Fire handling and emergency measures training",
            subEntries: [
                {
                    subtitle: "Relax Gaming",
                    dateRange: "2020",
                    fontawesome: faCertificate
                }
            ]
        },
        {
            title: "Game of Codes by ICTSA Malta",
            description: "1st Place in student / industry category of competitions",
            subEntries: [
                {
                    subtitle: "Origami Folding algorithm - Student & Industry category",
                    dateRange: "29 Nov - 1 Dec 2013",
                    fontawesome: faCertificate
                },
                {
                    subtitle: "Collage Making algorithm - Industry category",
                    dateRange: "20-22 Nov 2015",
                    fontawesome: faCertificate
                }
            ]
        },
        {
            title: "Calligraphy",
            description: "Degree Plus course on basic Calligraphy",
            subEntries: [
                {
                    subtitle: "University of Malta",
                    dateRange: "Oct 2011 - Jun 2012",
                    fontawesome: faCertificate
                }
            ]
        },
        {
            title: "Food Handling B",
            description: "Certification allowing food handling",
            subEntries: [
                {
                    subtitle: "St. Bernard's Health & Safety",
                    dateRange: "Aug 2018",
                    fontawesome: faCertificate
                },
                {
                    subtitle: "Stephen Mifsud Msc",
                    dateRange: "Jun 2009",
                    fontawesome: faCertificate
                }
            ]
        },
        {
            title: "Piano & Music Theory",
            description: "Grade 5 Piano and Music Theory",
            subEntries: [
                {
                    subtitle: "Trinity College London",
                    dateRange: "May - Jun 2008",
                    fontawesome: faCertificate
                }
            ]
        }
    ];

    static languages : LanguageDetailsProps[] = [
        {
            name: "English",
            icon: "gb",
            rank: 5
        },
        {
            name: "Maltese",
            icon: "mt",
            rank: 5
        },
        {
            name: "Italian",
            icon: "it",
            rank: 4
        },
        {
            name: "French",
            icon: "fr",
            rank: 3
        },
        {
            name: "Japanese",
            icon: "jp",
            rank: 1
        }
    ];

    range(size:number):ReadonlyArray<number> {
        // @ts-ignore
        return [...Array(size).keys()];
    }


    render() {
        return (<main className="History" role="main">
            <div className="History-Content">
                <section id="work-experience" aria-labelledby="work-experience-heading">
                    <h1 id="work-experience-heading">Work Experience</h1>
                    {
                        History.workExperience.map(w => <HistoryEntry key={"History-Entry-Work-"+w.title.replace(/\s+/g, '')} parentKey={"History-Entry-Work-"+w.title.replace(/\s+/g, '')} {...w}></HistoryEntry>)
                    }
                </section>
                <section id="personal-projects" aria-labelledby="personal-projects-heading">
                    <h1 id="personal-projects-heading">Personal Projects</h1>
                    {
                        History.personalProjects.map(w => <HistoryEntry key={"History-Entry-PersonalProjects-"+w.title.replace(/\s+/g, '')} parentKey={"History-Entry-PersonalProjects-"+w.title.replace(/\s+/g, '')} expandable={true} {...w}></HistoryEntry>)
                    }
                </section>
                <section id="education" aria-labelledby="education-heading">
                    <h1 id="education-heading">Education</h1>
                    {
                        History.education.map(w => <HistoryEntry key={"History-Entry-Education-"+w.title.replace(/\s+/g, '')} parentKey={"History-Entry-Education-"+w.title.replace(/\s+/g, '')} expandable={true} {...w}></HistoryEntry>)
                    }
                </section>
                <section id="certification" aria-labelledby="certification-heading">
                    <h1 id="certification-heading">Certification</h1>
                    {
                        History.awardsAndCertifications.map(w => <HistoryEntry key={"History-Entry-Awards-"+w.title.replace(/\s+/g, '')} parentKey={"History-Entry-Awards-"+w.title.replace(/\s+/g, '')} expandable={true} {...w}></HistoryEntry>)
                    }
                </section>
                                <section id="fluency" aria-labelledby="fluency-heading">
                    <h1 id="fluency-heading">Fluency</h1>
                    {
                        // we group each language into sets of 3
                        this.range(History.languages.length)
                            .map(i => Math.floor(i/2))
                            .filter((v,i,s) => s.indexOf(v) === i) // distinct
                            .map(i => {
                                return <div className="History-Language-Wrapper" key={"History-Languages-Wrapper-"+i}>
                                    {
                                        this.range(2).map(y => i*2+y).filter(y => y < History.languages.length)
                                            .map(y => {
                                                let w : LanguageDetailsProps = History.languages[y];
                                                return <div  key={"Lang-"+y} className={"LanguageWrapperDiv"}><LanguageDetails key={"History-Entry-Language"+w.name} {...w}></LanguageDetails></div>
                                            })
                                    }
                                </div>;
                            })
                    }
                </section>

            </div>
        </main>)
    }
}